(() => {
  const reader = document.querySelector('[data-story-reader]');
  if (!reader) return;

  const stage = reader.querySelector('[data-story-stage]');
  const views = [...reader.querySelectorAll('[data-story-view]')];
  const prev = reader.querySelector('[data-story-prev]');
  const next = reader.querySelector('[data-story-next]');
  const counter = reader.querySelector('[data-story-counter]');
  const chapters = [...reader.querySelectorAll('[data-story-jump]')];
  const strings = JSON.parse(document.querySelector('[data-story-strings]').textContent);
  const mobileQuery = window.matchMedia('(max-width:700px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion:reduce)');
  let view = 0;
  let side = 0;
  let busy = false;
  let touchX = null;
  let touchY = null;

  const mobile = () => mobileQuery.matches;
  const pageAt = (viewIndex, pageSide) => views[viewIndex]?.querySelectorAll('[data-story-page]')[pageSide];
  const atEnd = () => view === 3 && (!mobile() || side === 1);

  function render() {
    views.forEach((node, index) => {
      const active = index === view;
      node.classList.toggle('is-active', active);
      node.setAttribute('aria-hidden', String(!active));
      node.querySelectorAll('[data-story-page]').forEach((page, pageIndex) => {
        page.classList.toggle('is-mobile-visible', active && mobile() && side === pageIndex);
      });
    });
    prev.disabled = view === 0;
    next.disabled = atEnd();
    if (view === 0) counter.textContent = strings.cover;
    else if (mobile()) counter.textContent = `${strings.mobile} ${(view - 1) * 2 + side + 1} ${strings.ofSix}`;
    else counter.textContent = `${strings.spread} ${view} ${strings.ofThree}`;
    chapters.forEach(button => {
      if (Number(button.dataset.storyJump) === view) button.setAttribute('aria-current', 'step');
      else button.removeAttribute('aria-current');
    });
  }

  function change(targetView, targetSide, direction) {
    if (busy || (view === targetView && side === targetSide)) return;
    if (reducedMotion.matches || targetView === 0) {
      view = targetView;
      side = targetSide;
      render();
      return;
    }
    if (view === 0) {
      busy = true;
      const cover = reader.querySelector('[data-story-open]');
      cover.classList.add('is-opening');
      window.setTimeout(() => {
        view = targetView;
        side = targetSide;
        render();
        cover.classList.remove('is-opening');
        busy = false;
      }, 450);
      return;
    }

    const oldPage = pageAt(view, mobile() ? side : direction > 0 ? 1 : 0);
    const newPage = pageAt(targetView, mobile() ? targetSide : direction > 0 ? 0 : 1);
    if (!oldPage || !newPage) return;
    busy = true;
    const turn = document.createElement('div');
    turn.className = `story-reader__turn story-reader__turn--${direction > 0 ? 'forward' : 'backward'}`;
    const front = document.createElement('div');
    front.className = 'story-reader__turn-face story-reader__turn-face--front';
    front.append(oldPage.cloneNode(true));
    const back = document.createElement('div');
    back.className = 'story-reader__turn-face story-reader__turn-face--back';
    back.append(newPage.cloneNode(true));
    turn.append(front, back);

    let hold = null;
    if (!mobile()) {
      hold = document.createElement('div');
      hold.className = `story-reader__hold story-reader__hold--${direction > 0 ? 'left' : 'right'}`;
      hold.append(pageAt(view, direction > 0 ? 0 : 1).cloneNode(true));
      stage.append(hold);
      window.setTimeout(() => hold?.remove(), 260);
    }

    view = targetView;
    side = targetSide;
    render();
    stage.append(turn);
    window.setTimeout(() => {
      turn.remove();
      hold?.remove();
      busy = false;
    }, 530);
  }

  function forward() {
    if (busy || atEnd()) return;
    if (view === 0) change(1, 0, 1);
    else if (mobile() && side === 0) change(view, 1, 1);
    else change(view + 1, 0, 1);
  }

  function backward() {
    if (busy || view === 0) return;
    if (mobile() && side === 1) change(view, 0, -1);
    else if (view === 1) change(0, 0, -1);
    else change(view - 1, mobile() ? 1 : 0, -1);
  }

  reader.querySelector('[data-story-open]').addEventListener('click', forward);
  next.addEventListener('click', forward);
  prev.addEventListener('click', backward);
  chapters.forEach(button => button.addEventListener('click', () => {
    const target = Number(button.dataset.storyJump);
    change(target, 0, target > view ? 1 : -1);
  }));
  stage.addEventListener('click', event => {
    if (event.target.closest('button') || view === 0) return;
    const x = event.clientX - stage.getBoundingClientRect().left;
    if (x < stage.clientWidth * .22) backward();
    else if (x > stage.clientWidth * .78) forward();
  });
  stage.addEventListener('touchstart', event => {
    touchX = event.changedTouches[0].clientX;
    touchY = event.changedTouches[0].clientY;
  }, { passive: true });
  stage.addEventListener('touchend', event => {
    if (touchX === null) return;
    const dx = event.changedTouches[0].clientX - touchX;
    const dy = event.changedTouches[0].clientY - touchY;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
      if (dx < 0) forward();
      else backward();
    }
    touchX = null;
    touchY = null;
  }, { passive: true });
  reader.addEventListener('keydown', event => {
    if (event.key === 'ArrowRight') { event.preventDefault(); forward(); }
    if (event.key === 'ArrowLeft') { event.preventDefault(); backward(); }
  });
  mobileQuery.addEventListener('change', () => { side = 0; render(); });
  render();
})();
